(() => {
  const init = () => {
    document.querySelectorAll('[data-seh-header]').forEach((header) => {
      const toggle = header.querySelector('[data-seh-menu-toggle]');
      const menu = header.querySelector('[data-seh-mobile-menu]');
      if (toggle && menu && !toggle.dataset.ready) {
        toggle.dataset.ready = 'true';
        toggle.addEventListener('click', () => {
          const open = toggle.getAttribute('aria-expanded') === 'true';
          toggle.setAttribute('aria-expanded', String(!open));
          menu.hidden = open;
        });
      }
    });

    document.querySelectorAll('[data-seh-countdown]').forEach((clock) => {
      if (clock.dataset.ready) return;
      clock.dataset.ready = 'true';
      const key = 'sleepease-home-countdown';
      const duration = Math.max(1, Number(clock.dataset.hours) || 12) * 3600000;
      let end = Number(sessionStorage.getItem(key));
      if (!end || end < Date.now()) { end = Date.now() + duration; sessionStorage.setItem(key, String(end)); }
      const update = () => {
        let remaining = Math.max(0, end - Date.now());
        if (!remaining) { end = Date.now() + duration; sessionStorage.setItem(key, String(end)); remaining = duration; }
        const total = Math.floor(remaining / 1000);
        clock.querySelector('[data-seh-hours]').textContent = String(Math.floor(total / 3600)).padStart(2, '0');
        clock.querySelector('[data-seh-minutes]').textContent = String(Math.floor((total % 3600) / 60)).padStart(2, '0');
        clock.querySelector('[data-seh-seconds]').textContent = String(total % 60).padStart(2, '0');
      };
      update(); setInterval(update, 1000);
    });
  };
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
